import { Resource } from '@teem/generic/resource';
import { Serializer } from '@teem/generic/serializer';
import * as moment from 'moment';

export class CouponSerializer implements Serializer {
  fromJson(json: any): Coupon {
    let couponService = new Coupon(json);
    return couponService;
  }

  toJson(coupon: Coupon): any {
    return coupon;
  }
}

export class Coupon implements Resource {
  public uuid: string;
  public user_id: number;
  public coupon_code: string;
  public discount: number;
  public coupons: string;
  public discount_type: string;
  public start_date: string = moment().format('DD/MM/YYYY');
  public end_date: string = moment().format('DD/MM/YYYY');
  public number_of_times: string;
  public is_active: string;
  public is_draft: string;
  constructor(input?: any) {

    if (input) {
      Object.assign(this, input);
    }
  }
}
